import React, { useEffect, useState } from 'react'
import TotalCampaignIcon from './icons/TotalCampaignIcon'
import ActiveCampaignIcon from './icons/ActiveCampaignsIcon'
import { Link } from 'react-router-dom'
import MarketingService from '../../../api/MarketingService'
import { toast } from 'react-toastify'

export default function MarketingDashboard() {
  const [campaignDashboardData, setCampaignDashboardData] = useState({total_active_campaign:0,total_campaign:0})
  useEffect(() => {
    getCampaignDashboardData()
  }, [])

  const getCampaignDashboardData = () => {
    MarketingService.getCampaignDashboardData().then(
      (res: any) => {
        if (res?.data?.success) {
          setCampaignDashboardData(res?.data?.data)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
          setCampaignDashboardData({total_active_campaign:0,total_campaign:0})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  return (
    <>
      <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
        <p style={{fontSize: 30, color: '#686868'}}>Campaigns 🎉</p>
        <Link
         to='/add-campaign'
          type='button'
          style={{
            backgroundColor: '#EBF3F8',
            borderRadius: 113,
            width: 226,
            height: 56,
            fontSize: 16,
            color: '#161616',
            fontWeight: 'bold',
            textAlign:'center',
            alignContent:'center'
          }}
        >
          + New Campaign
        </Link>
      </div>
      <div className='row g-xl-10 mb-5 mb-xl-5 mt-10'>
        {/* begin::Col */}
            <div onClick={()=>{}}
             className='col-md-6 col-xl-3 col-12 m-2 cursor-pointer'
              style={{
                height: 114,
                backgroundColor: '#373737',
                borderRadius: 10,
                flexDirection: 'row',
                display: 'flex',justifyContent:'space-evenly', alignItems:'center',
              }}
            >
              <div style={{padding:10, backgroundColor:'rgba(34, 166, 179, 0.15)', borderRadius:50}}>
                <TotalCampaignIcon/>
              </div>
              <div style={{flexDirection: 'column'}}>
                <p style={{fontSize: 18, color: '#FFF', margin:0}}>Total Campaigns</p>
                <p style={{fontSize: 40, fontWeight: 'bold', color: '#FFF', margin:0}}>{campaignDashboardData?.total_campaign}</p>
              </div>
          </div>
          <div onClick={()=>{}}
             className='col-md-6 col-xl-3 col-12 m-2 cursor-pointer'
              style={{
                height: 114,
                backgroundColor: '#4DFF0E',
                borderRadius: 10,
                flexDirection: 'row',
                display: 'flex',justifyContent:'space-evenly', alignItems:'center',
              }}
            >
              <div style={{padding:10, backgroundColor:'rgba(34, 166, 179, 0.15)', borderRadius:50}}>
                <ActiveCampaignIcon/>
              </div>
              <div style={{flexDirection: 'column'}}>
                <p style={{fontSize: 18, color: '#FFF', margin:0}}>Active Campaigns</p>
                <p style={{fontSize: 40, fontWeight: 'bold', color: '#FFF', margin:0}}>{campaignDashboardData?.total_active_campaign}</p>
              </div>
          </div>
      </div>
    </>
  )
}
